'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _button = require('./button');

var _button2 = _interopRequireDefault(_button);

var _button_area = require('./button_area');

var _button_area2 = _interopRequireDefault(_button_area);

var _button_preview = require('./button_preview');

var _button_preview2 = _interopRequireDefault(_button_preview);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    Button: _button2.default,
    ButtonArea: _button_area2.default,
    PreviewButton: _button_preview2.default
}; /**
    * Created by jf on 15/10/27.
    */

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-weui/lib/components/button/index.js
// module id = 514
// module chunks = 7